import CheckBoxIcon from '@material-ui/icons/CheckBox';
import CheckBoxOutlineBlankOutlinedIcon from '@material-ui/icons/CheckBoxOutlineBlankOutlined';
import CSS from 'csstype';
import React, { JSX, useState } from 'react';

import { ISelectOption } from '~/src/dash/components/dropdowns/common';
import { Col, Cols, Row, spacing, Text, TooltipWithTranslation } from '~/src/dash/publicaUI';
import { publicaColors } from '~/src/dash/utils/colors';

const checkboxStyle: CSS.Properties = {
  marginRight: spacing.small,
  color: publicaColors.darkGray,
};

interface IVirtualSelectRowProps {
  handleOnChange: (option: ISelectOption) => void;
  index: number;
  options: ISelectOption[];
  selectedIDs: Set<string | number>;
  isCheckboxHidden: boolean;
  style: React.CSSProperties;
  displayID?: boolean;
  enableLabelTooltip?: boolean;
  textWidth?: number;
}

export const VirtualSelectRow = ({
  index,
  style,
  options,
  handleOnChange,
  displayID = false,
  enableLabelTooltip,
  selectedIDs,
  isCheckboxHidden,
  textWidth = 320,
}: IVirtualSelectRowProps): JSX.Element => {
  const { id, label, tKey, tProps } = options[index];
  const isSelected = selectedIDs.has(id);
  const [isHovered, setIsHovered] = useState(false);

  return (
    <Row
      onClick={() => handleOnChange(options[index])}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      style={
        {
          ...style,
          cursor: 'pointer',
          padding: '4px 8px 0px',
          backgroundColor: isHovered ? publicaColors.veryLightGray : 'inherit',
        } as CSS.Properties
      }
      className={`virtual-row-${index}`}
    >
      <Cols gap={spacing.small} style={{ alignItems: 'flex-start' }}>
        {!isCheckboxHidden && (
          <Col>
            {isSelected ? (
              <CheckBoxIcon style={checkboxStyle} />
            ) : (
              <CheckBoxOutlineBlankOutlinedIcon style={checkboxStyle} />
            )}
          </Col>
        )}
        {displayID && (
          <Col style={{ minWidth: '40px', paddingTop: '1px' }}>
            <Text small muted bold={isSelected}>
              {id}
            </Text>
          </Col>
        )}
        <Col style={{ paddingTop: '1px' }}>
          <TooltipWithTranslation
            tKey={tKey}
            tProps={tProps}
            title={enableLabelTooltip ? label : ''}
          >
            <div>
              <Text
                small
                bold={isSelected}
                style={{
                  width: `${textWidth}px`,
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                }}
                tKey={tKey}
                tProps={tProps}
              >
                {label}
              </Text>
            </div>
          </TooltipWithTranslation>
        </Col>
      </Cols>
    </Row>
  );
};
